import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  alertApiRef,
  configApiRef,
  createApiFactory,
  createApiRef,
  storageApiRef,
} from '@backstage/core-plugin-api';
import {
  shortcutsApiRef,
  DefaultShortcutsApi,
} from '@backstage-community/plugin-shortcuts';
import { saltSquareTechRadarApiFactory } from './components/tech-radar/SaltSquareTechRadarApi';

const toastApiRef = createApiRef<{
  post(options: { title?: string; status?: string; timeout?: number }): {
    dismiss: () => void;
    close: () => void;
  };
}>({ id: 'core.toast' });

function toSeverity(status?: string): 'error' | 'success' | 'info' {
  if (status === 'danger') return 'error';
  if (status === 'success') return 'success';
  return 'info';
}

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiFactory({
    api: shortcutsApiRef,
    deps: { storageApi: storageApiRef },
    factory: ({ storageApi }) =>
      new DefaultShortcutsApi(storageApi.forBucket('shortcuts')),
  }),
  createApiFactory({
    api: toastApiRef,
    deps: { alertApi: alertApiRef },
    factory: ({ alertApi }) => ({
      post(options) {
        alertApi.post({
          message: String(options.title ?? ''),
          severity: toSeverity(options.status),
        });
        return { dismiss: () => {}, close: () => {} };
      },
    }),
  }),
  saltSquareTechRadarApiFactory,
];
